import { render, staticRenderFns } from "./DonorInfo.vue?vue&type=template&id=6282a568&"
import script from "./DonorInfo.vue?vue&type=script&lang=ts&"
export * from "./DonorInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports